// @flow

// Constants
import {
  MAP_BRANCH,
  PROP_SOIL_PROPS_MAP_BLOB_ID,
} from './../constants'

// Utils
import traverse from 'fc-utils/traverse'

export default (traverse([MAP_BRANCH, PROP_SOIL_PROPS_MAP_BLOB_ID]))
